import zhCN from 'antd/lib/locale-provider/zh_CN';
import zhCNMessages from "@/lngProvider/locales/zh-Hans-CN.json";

const ZhLan = {
  messages: {
    ...zhCNMessages
  },
  antd: zhCN,
  locale: 'zh-Hans-CN',
};
export default ZhLan;
